<template>
  <select
    v-if="filterResources.length"
    v-model="selectedFilter"
    class="input gx-last"
  >
    <option :value="null">
      <template v-if="selectedFilter === null">
        {{ $t('filter_select_default_active') }}
      </template>
      <template v-else>
        {{ $t('filter_select_default') }}
      </template>
    </option>
    <option
      v-for="filter in availableFilters"
      :key="filter.properties.key"
      :value="filter"
    >
      {{ filter.properties.name }}
    </option>
  </select>
</template>

<script>
import { Event, Query, Resource, Type } from '@/src/server/helpers/constants'
import { strCompare, capitalize } from '@/src/server/helpers/string'

export default {
  data () {
    return {
      disciplines: [],
      tags: [],
      storedFilter: undefined,
    }
  },

  computed: {
    manager () {
      return this.$route.query.manager
    },
    filterResources () {
      const availableFilters = [
        Resource.DISCIPLINE,
        Resource.TAG,
      ]

      if (this.$route.query.filters === Query.TRUE) {
        return availableFilters
      } else {
        return (this.$route.query.filters || '').split(',')
          .filter((resource) => availableFilters.includes(resource))
      }
    },
    selectedFilter: {
      get () {
        if (this.storedFilter !== undefined) {
          return this.storedFilter
        } else {
          return this.queryFilter || null
        }
      },
      set (value) {
        this.storedFilter = value
        this.$emit(Event.CHANGE_FILTER, value)
      },
    },
    queryFilter () {
      const [type, id] = (this.$route.query.only || '').split(':')

      if (id) {
        return this.availableFilters
          .find((filter) => filter.type === type && filter.id === id)
      }
    },
    availableFilters () {
      return [].concat(this.disciplines, this.tags)
        .sort((a, b) => strCompare(a.properties.name, b.properties.name))
    },
  },

  created () {
    this.fetchFilters()
  },

  methods: {
    fetchFilters () {
      this.fetchDisciplines()
      this.fetchTags()
    },
    fetchDisciplines () {
      if (this.manager) {
        if (this.filterResources.includes(Resource.DISCIPLINE)) {
          const disciplinesOptions = {
            params: {
              filter: `${Type.MANAGER}.id:${this.manager}`,
              include: Type.DISCIPLINE,
            },
          }

          this.$axios(Resource.DISCIPLINEMANAGER, disciplinesOptions)
            .then((response) => {
              this.disciplines = this.preprocessDisciplines(response.data.included)
            })
        }
      }
    },
    fetchTags () {
      if (this.manager) {
        if (this.filterResources.includes(Resource.TAG)) {
          const tagsOptions = {
            params: {
              filter: [
                `featured:${Query.TRUE}`,
                `${Type.MANAGER}.id:${this.manager}`,
              ].join(','),
            },
          }

          this.$axios(Resource.TAG, tagsOptions)
            .then((response) => {
              this.tags = this.preprocessTags(response.data.data)
            })
        }
      }
    },
    preprocessDisciplines (disciplines = []) {
      return disciplines.map((discipline) => {
        discipline.properties = {
          name: capitalize(this.$t('disciplines.' + discipline.attributes.name)),
          key: Type.DISCIPLINE + '_' + discipline.id,
        }

        return discipline
      })
    },
    preprocessTags (tags = []) {
      return tags.map((tag) => {
        tag.properties = {
          name: tag.attributes.name,
          key: Type.TAG + '_' + tag.id,
        }

        return tag
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/server/components/shared/FilterSelect.vue